module.exports = __webpack_public_path__ + "img/qfcm-img4.478b2b04.png";